var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupprimerCompte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 38.4c-0.883 0-1.6-0.717-1.6-1.6v-28.8c0-0.883 0.717-1.6 1.6-1.6s1.6 0.717 1.6 1.6v28.8c0 0.883-0.717 1.6-1.6 1.6z",
    fill: "#223654"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 60.8c-6.41 0-12.438-2.496-16.97-7.030s-7.030-10.56-7.030-16.97c0-5.274 1.68-10.278 4.854-14.474 3.072-4.058 7.437-7.088 12.288-8.531 0.848-0.253 1.738 0.23 1.99 1.078s-0.23 1.738-1.078 1.99c-8.746 2.605-14.858 10.803-14.858 19.939 0 11.469 9.331 20.8 20.8 20.8s20.8-9.331 20.8-20.8c0-9.136-6.109-17.334-14.858-19.939-0.848-0.253-1.328-1.142-1.078-1.99s1.142-1.328 1.99-1.078c4.854 1.443 9.216 4.474 12.288 8.531 3.178 4.195 4.854 9.2 4.854 14.474 0 6.41-2.496 12.438-7.030 16.97s-10.56 7.030-16.97 7.030h0.006z",
    fill: "#223654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupprimerCompte);
export default __webpack_public_path__ + "static/media/supprimer-compte.c9e1d2aab8c6fe0b46affec1039e9ab7.svg";
export { ForwardRef as ReactComponent };